import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ToggleGroup } from 'components/_common/ToggleGroup';
import { LengthUnits, RTRMetricUnit, UserSystemGroup } from 'store/storeTypes';
import { styles } from './Settings.styles';

interface DesktopDTFUnitsProps {
  userSettings: any;
  updatedSettings: any;
  handleChangeLength: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
  handleChangeMetrics: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
}

const DesktopDTFUnits: React.FC<DesktopDTFUnitsProps> = ({
  userSettings,
  updatedSettings,
  handleChangeLength,
  handleChangeMetrics,
}) => {
  const { t } = useTranslation();

  if (!userSettings.data.userSystemGroup?.includes(UserSystemGroup.DTF)) {
    return null;
  }

  return (
    <Box sx={styles.section}>
      <Box sx={styles.sectionTitleWrapper}>
        <Typography variant="h3" sx={styles.sectionTitle}>
          {t('settings.dtfUnits')}
        </Typography>
      </Box>
      <Box sx={styles.sectionList}>
        <Box sx={styles.sectionListItem}>
          <Box sx={styles.sectionListItemWrapper}>
            <Box sx={styles.sectionListItemLeftPart}>
              <Typography sx={styles.sectionListItemTitle}>{t('settings.length')}</Typography>
            </Box>
            <Box sx={styles.sectionListItemRightPart}>
              <ToggleGroup
                value={
                  updatedSettings && updatedSettings.hasOwnProperty('lengthUnits')
                    ? updatedSettings.lengthUnits
                    : userSettings.data?.lengthUnits
                }
                onChange={handleChangeLength}
                name={'lengthUnits'}
                data={[
                  {
                    value: LengthUnits.Yard,
                    label: 'Yard',
                  },
                  {
                    value: LengthUnits.Meter,
                    label: 'Meter',
                  },
                ]}
              />
            </Box>
          </Box>
        </Box>
        <Box sx={styles.sectionListItem}>
          <Box sx={styles.sectionListItemWrapper}>
            <Box sx={styles.sectionListItemLeftPart}>
              <Typography sx={styles.sectionListItemTitle}>{t('settings.rtrMetrics')}</Typography>
            </Box>
            <Box sx={styles.sectionListItemRightPart}>
              <ToggleGroup
                value={
                  updatedSettings && updatedSettings.hasOwnProperty('rtrMetricUnit')
                    ? updatedSettings.rtrMetricUnit
                    : userSettings.data?.rtrMetricUnit
                }
                name={'rtrMetricUnit'}
                onChange={handleChangeMetrics}
                data={[
                  {
                    value: RTRMetricUnit.Linear,
                    label: 'Linear',
                  },
                  {
                    value: RTRMetricUnit.Square,
                    label: 'Square',
                  },
                ]}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DesktopDTFUnits;
